"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireWildcard(require("react"));

var _layout = _interopRequireDefault(require("./layout"));

var _constants = require("../../constants");

var LightboxContainer = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(LightboxContainer, _Component);

  var _super = (0, _createSuper2["default"])(LightboxContainer);

  function LightboxContainer(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, LightboxContainer);
    _this = _super.call(this, props);

    _this.onToNext = function () {
      return _this.setState(function (prevState) {
        return {
          index: prevState.index + 1
        };
      });
    };

    _this.onToPrevious = function () {
      return _this.setState(function (prevState) {
        return {
          index: prevState.index - 1
        };
      });
    };

    _this.hasNext = function (index) {
      var media = _this.props.media;
      return !!media[index + 1];
    };

    _this.hasPrevious = function (index) {
      var media = _this.props.media;
      return !!media[index - 1];
    };

    _this.onKeyPress = function (_ref) {
      var keyCode = _ref.keyCode;
      var onClose = _this.props.onClose;
      var index = _this.state.index;

      if (keyCode === _constants.KEY_CODES.ARROW_RIGHT && _this.hasNext(index)) {
        _this.onToNext();
      } else if (keyCode === _constants.KEY_CODES.ARROW_LEFT && _this.hasPrevious(index)) {
        _this.onToPrevious();
      } else if (keyCode === _constants.KEY_CODES.ESCAPE) {
        onClose();
      }
    };

    _this.state = {
      index: props.index
    };
    return _this;
  }

  (0, _createClass2["default"])(LightboxContainer, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_layout["default"], Object.assign({}, this.props, this.state, {
        onToNext: this.onToNext,
        onToPrevious: this.onToPrevious,
        hasNext: this.hasNext,
        hasPrevious: this.hasPrevious,
        onKeyPress: this.onKeyPress
      }));
    }
  }]);
  return LightboxContainer;
}(_react.Component);

exports["default"] = LightboxContainer;